import apiSportsClubs from '@/api/sports-clubs'

const state = {
    validationErrors: null,
    isSubmitting: false
}

export const mutationTypes = {
    deleteSportClubsStart: '[delete sportsClubs] deleteSportClubsStart',
    deleteSportClubsSuccess: '[delete sportsClubs] deleteSportClubsSuccess',
    deleteSportClubsFailure: '[delete sportsClubs] deleteSportClubsFailure'
}

export const actionType = {
    deleteSportClubs: '[delete sportsClubs] deleteSportClubs'
}

const mutations = {
    [mutationTypes.deleteSportClubsStart](state) {
        state.isSubmitting = true
        state.validationErrors = null
    },

    [mutationTypes.deleteSportClubsSuccess](state) {
        state.isSubmitting = false
    },

    [mutationTypes.deleteSportClubsFailure](state, payload) {
        state.isSubmitting = false
        state.validationErrors = payload
    }
}

const actions = {
    [actionType.deleteSportClubs](context, {id}) {
        context.commit(mutationTypes.deleteSportClubsStart)
        return new Promise(resolve => {
            apiSportsClubs
                .deleteSportClub(id)
                .then(response => {
                    context.commit(mutationTypes.deleteSportClubsSuccess, response.data)
                    resolve(response.data)
                })
                .catch(result => {
                    context.commit(
                        mutationTypes.deleteSportClubsFailure,
                        result.response.data.errors
                    )
                })
        })
    }
}

export default {
    state,
    mutations,
    actions
}
